// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1qPOo","inputWrap":"styles_inputWrap__Hblr-","input":"styles_input__dPuVY"};